var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ConfigFile, Preferences, ProjectConfig } from "./ProjectConfig";
var ConfigServiceBase = /** @class */ (function () {
    function ConfigServiceBase(configFetcher, baseConfig) {
        this.fetchLogicLock = false;
        this.fetchLogicCallbacks = [];
        this.configFetcher = configFetcher;
        this.baseConfig = baseConfig;
    }
    ConfigServiceBase.prototype.refreshLogicBaseAsync = function (lastProjectConfig, forceUpdateCache) {
        var _this = this;
        if (forceUpdateCache === void 0) { forceUpdateCache = true; }
        return new Promise(function (resolve) {
            _this.fetchLogic(_this.baseConfig, lastProjectConfig, 0, function (newConfig) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(newConfig && newConfig.ConfigJSON)) return [3 /*break*/, 3];
                            if (!(forceUpdateCache || !ProjectConfig.equals(newConfig, lastProjectConfig))) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.baseConfig.cache.set(this.baseConfig.getCacheKey(), newConfig)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            resolve(newConfig);
                            return [3 /*break*/, 4];
                        case 3:
                            resolve(lastProjectConfig);
                            _a.label = 4;
                        case 4: return [2 /*return*/];
                    }
                });
            }); });
        });
    };
    ConfigServiceBase.prototype.fetchLogic = function (options, lastProjectConfig, retries, callback) {
        var _this = this;
        var calledBaseUrl = this.baseConfig.baseUrl;
        this.fetchLogicInternal(this.baseConfig, lastProjectConfig, retries, function (newConfig) {
            if (!newConfig || !newConfig.ConfigJSON) {
                callback(null);
                return;
            }
            var preferences = newConfig.ConfigJSON[ConfigFile.Preferences];
            if (!preferences) {
                callback(newConfig);
                return;
            }
            var baseUrl = preferences[Preferences.BaseUrl];
            // If the base_url is the same as the last called one, just return the response.
            if (!baseUrl || baseUrl == calledBaseUrl) {
                callback(newConfig);
                return;
            }
            var redirect = preferences[Preferences.Redirect];
            // If the base_url is overridden, and the redirect parameter is not 2 (force),
            // the SDK should not redirect the calls and it just have to return the response.
            if (options.baseUrlOverriden && redirect !== 2) {
                callback(newConfig);
                return;
            }
            options.baseUrl = baseUrl;
            if (redirect === 0) {
                callback(newConfig);
                return;
            }
            if (redirect === 1) {
                options.logger.warn("Your dataGovernance parameter at ConfigCatClient initialization is not in sync " +
                    "with your preferences on the ConfigCat Dashboard: " +
                    "https://app.configcat.com/organization/data-governance. " +
                    "Only Organization Admins can access this preference.");
            }
            if (retries >= 2) {
                options.logger.error("Redirect loop during config.json fetch. Please contact support@configcat.com.");
                callback(newConfig);
                return;
            }
            _this.fetchLogic(options, lastProjectConfig, ++retries, callback);
            return;
        });
    };
    ConfigServiceBase.prototype.fetchLogicInternal = function (options, lastProjectConfig, retries, callback) {
        var _this = this;
        if (retries === 0) {
            // Only lock on the top-level calls, not on the recursive calls (config.json redirections).
            this.fetchLogicCallbacks.push(callback);
            if (this.fetchLogicCallbacks.length > 1) {
                // The first fetchLogic call is already in progress.
                return;
            }
            this.configFetcher.fetchLogic(options, lastProjectConfig, function (newProjectConfig) {
                while (_this.fetchLogicCallbacks.length) {
                    var thisCallback = _this.fetchLogicCallbacks.pop();
                    if (thisCallback) {
                        thisCallback(newProjectConfig);
                    }
                }
            });
        }
        else {
            // Recursive calls should call the fetchLogic as is.
            this.configFetcher.fetchLogic(options, lastProjectConfig, callback);
        }
    };
    return ConfigServiceBase;
}());
export { ConfigServiceBase };
